import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { PartnerApi } from "../../sdk/services/custom";
import { InfiniteScrollComponent } from '../../components/inifiniteScrollComponent';
import { IPartner } from '../../models';
import { LoadingComponent } from '../../components/loadingComponent';


@IonicPage({
    segment: 'home',
    name: 'HomePage'
})
@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
})
export class HomePage extends InfiniteScrollComponent {

    constructor(
        public navParams: NavParams,
        public partnerService: PartnerApi,
        public loading: LoadingComponent
    ) { 

        super(partnerService);
        this.filterLimit = 20;
        this.filterFields = IPartner.FIELDS;
    }

    /**
     * Al cargar la pagina
     */
    ionViewDidLoad() {
        
        //cargar proveedores al inicio
        this.loadDataApi().toPromise().then((allPartners: any[]) => {
            //insertar items en lista
            this.listItems = allPartners;
        });
    }

    /**
   * Function abstracta que devuelve el LoadingComponent
   */
    public getLoadingComponent():LoadingComponent{
        return this.loading;
    }



}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts